import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from "@mui/material";
import { GoogleMap, Marker, LoadScriptNext } from "@react-google-maps/api";

const ServiceManLocation = ({ open, onClose, latitude, longitude }) => {
  const mapContainerStyle = {
    height: "400px",
    width: "100%",
  };

  const isValidCoordinate = (value) =>
    typeof value === "number" && isFinite(value);

  const isValidLocation =
    isValidCoordinate(latitude) && isValidCoordinate(longitude);
  const center = isValidLocation ? { lat: latitude, lng: longitude } : null;

  const options = {
    streetViewControl: false,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      aria-labelledby="service-dialog-title"
    >
      <DialogTitle id="service-dialog-title" style={{ color: "#ff4d4d" }}>
        ServiceMan Location
      </DialogTitle>
      <DialogContent dividers>
        {isValidLocation ? (
          <LoadScriptNext googleMapsApiKey={process.env.REACT_APP_SECRET_KEY}>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={center}
              zoom={14}
              options={options}
            >
              <Marker position={center} />
            </GoogleMap>
          </LoadScriptNext>
        ) : (
          <Typography variant="h6" color="error" align="center">
            The worker's location is currently unavailable.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceManLocation;
